import { useEffect, useRef } from "react";
import Select from "react-select";
import type { HandleSingleSelectChange, SelectValue } from "ui-kit/src/MultipleSelect/types";
import { adminSelectBaseProps } from "./adminSelectStyles";

export interface AdminSelectOption {
	value: number | string;
	label: string;
	type?: string;
}

interface AdminSelectGroup {
	label: string;
	options: AdminSelectOption[];
}

type AdminSelectItems = AdminSelectOption | AdminSelectGroup;

interface AdminSelectComponentProps {
	items?: AdminSelectItems[];
	placeholder?: string;
	value?: SelectValue;
	handleChange: HandleSingleSelectChange;
	isCleareable?: boolean;
	menuPortalTarget?: boolean;
	isLoading?: boolean;
	isDisabled?: boolean;
	referenced?: boolean;
}

/** Admin-only single select. Same API as ui-kit SelectComponent, admin styling. */
export default function AdminSelectComponent({
	value,
	placeholder,
	items,
	handleChange,
	isCleareable = true,
	menuPortalTarget,
	isLoading,
	isDisabled,
	referenced = false,
}: AdminSelectComponentProps) {
	const selectRef = useRef<Select<AdminSelectOption, false> | null>(null);

	useEffect(() => {
		if (referenced && value?.value === undefined && selectRef.current) {
			selectRef.current.clearValue();
		}
	}, [referenced, value]);

	return (
		<Select
			ref={referenced ? selectRef : undefined}
			{...adminSelectBaseProps}
			menuPortalTarget={menuPortalTarget ? document.body : adminSelectBaseProps.menuPortalTarget}
			value={value}
			isLoading={isLoading}
			isClearable={isCleareable}
			onChange={handleChange}
			closeMenuOnSelect
			placeholder={placeholder}
			options={items}
			isDisabled={isDisabled}
		/>
	);
}
